<template>
    <div class="main">
        <b-button
            class="noprint px-2 rounded-circle"
            v-b-toggle.sidebar
            style="position: fixed; bottom: 20px; left: 20px"
        >
            <b-icon icon="gear-fill" aria-hidden="true"></b-icon>
        </b-button>
        <b-sidebar class="noprint" id="sidebar" title="Discount" width="380px">
            <b-container>
                <b-row class="discount-row">
                    <b-col
                        ><b-form-select
                            v-model="set"
                            :options="setOptions"
                            @change="changeSet"
                        >
                        </b-form-select
                    ></b-col>
                </b-row>
                <b-row>
                    <b-col cols="9"></b-col>
                    <b-col>
                        <b-button variant="primary" @click="onClickSaveSet()">
                            Save
                        </b-button>
                    </b-col>
                </b-row>
                <hr />
                <b-row class="discount-row">
                    <b-col cols="8">
                        <label>Total</label>
                    </b-col>
                    <b-col>
                        <b-form-input
                            :value="discount.total"
                            @input="
                                $emit('update:discount', {
                                    ...discount,
                                    total: $event,
                                })
                            "
                        ></b-form-input>
                    </b-col>
                </b-row>
                <hr />
                <b-row class="discount-row">
                    <b-col>
                        <label>CloudFront</label>
                    </b-col>
                </b-row>
                <b-row
                    v-for="(value, key) in discount.cloudfront"
                    :key="key"
                    class="discount-row"
                >
                    <b-col cols="8">
                        <label>{{ key }}</label>
                    </b-col>
                    <b-col>
                        <b-form-input
                            :value="discount.cloudfront[key]"
                            @input="
                                $emit('update:discount', {
                                    ...discount,
                                    cloudfront: {
                                        ...discount.cloudfront,
                                        [key]: $event,
                                    },
                                })
                            "
                        >
                        </b-form-input>
                    </b-col>
                </b-row>
            </b-container>
        </b-sidebar>
        <AddOrEditSetModal
            v-model="modalAddOrEdit"
            :setName="setOptions[set].text"
            @onDone="saveSet"
        ></AddOrEditSetModal>
    </div>
</template>

<script>
import AddOrEditSetModal from '@/views/Modals/AddOrEditSetModal/AddOrEditSetModal.vue';

export default {
    name: 'InvoiceDiscount',
    components: { AddOrEditSetModal },
    props: ['discount'],
    emits: ['update:discount'],
    mounted() {
        const storageData = localStorage.getItem('setData');
        if (storageData) {
            this.setData = JSON.parse(storageData);
            this.refreshData();
            this.$emit('update:discount', this.setData[this.set]);
        }
    },
    data() {
        return {
            set: 0,
            setOptions: [
                { value: 0, text: 'Slot 1' },
                { value: 1, text: 'Slot 2' },
                { value: 2, text: 'Slot 3' },
                { value: 3, text: 'Slot 4' },
                { value: 4, text: 'Slot 5' },
                { value: 5, text: 'Slot 6' },
                { value: 6, text: 'Slot 7' },
                { value: 7, text: 'Slot 8' },
                { value: 8, text: 'Slot 9' },
            ],
            setData: {},
            modalAddOrEdit: false,
        };
    },
    methods: {
        refreshData() {
            for (let i = 0; i < this.setOptions.length; i++) {
                if (this.setData[i]) {
                    this.setOptions[i].text = this.setData[i].setName;
                }
            }
        },
        changeSet() {
            this.$emit('update:discount', this.setData[this.set]);
        },
        onClickSaveSet() {
            this.modalAddOrEdit = true;
        },
        saveSet(setName) {
            this.setData[this.set] = {
                ...this.discount,
                setName: setName,
            };
            localStorage.setItem('setData', JSON.stringify(this.setData));
            this.refreshData();
        },
    },
};
</script>

<style lang="scss">
@import 'main';
@media print {
    .noprint {
        display: none;
    }
}
.discount-row {
    margin-bottom: 0.25rem;
}
</style>
